import { z } from "zod/mini";
import type { DatabaseProperties } from ":shared/database/database-properties";

export const DeckSchema = z.object({
	title: z.string(),
	description: z.optional(z.string()),
});

export type Deck = z.infer<typeof DeckSchema>;
export type DeckIdentifiable = Deck & DatabaseProperties;

export function createModel(input: Deck): Deck {
	const parsed = DeckSchema.parse(input);
	return parsed;
}
